import React, {useState} from 'react'
import {useTranslation} from "react-i18next";
import ServiceRequests from "../Accounts/Account/ServiceRequests/ServiceRequests";
import {Link} from 'react-router-dom'

const CardSummaryRequests = (props) => {
    const {t, i18n} = useTranslation();

    return <div className="cardsummary cardsummary--requests">
        <div className="cardsummary__content">
            <div className="d-flex flex-wrap">
                <div className="col-12">
                    <div className="cardsummary__content__box">
                       <div>
                           <h2 className="headline headline--section headline--margin--20">
                               {t("account.summary.requests.title")}
                           </h2>

                            <ServiceRequests isSummary={true} />
                       </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
};

export default CardSummaryRequests
